type Props = {
  color?: string;
};

export default function SelectedPharmacy({
  color = "var(--brand-primary-color)",
}: Props) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.916626"
        y="0.916626"
        width="20.1667"
        height="21.0833"
        fill={color}
      />
      <rect
        x="7.33337"
        y="10.0834"
        width="7.33333"
        height="11.9167"
        fill="white"
      />
      <rect
        x="1.83337"
        y="3.66663"
        width="18.3333"
        height="2.75"
        fill="white"
      />
      <path
        d="M0 1C0 0.447716 0.447715 0 1 0H21C21.5523 0 22 0.447715 22 1V2.66667C22 3.21895 21.5523 3.66667 21 3.66667H1C0.447716 3.66667 0 3.21895 0 2.66667V1Z"
        fill={color}
      />
      <path
        d="M0.5 21.0833C0.5 20.8532 0.686548 20.6666 0.916666 20.6666H21.0833C21.3135 20.6666 21.5 20.8532 21.5 21.0833C21.5 21.3134 21.3135 21.5 21.0833 21.5H0.916666C0.686548 21.5 0.5 21.3134 0.5 21.0833Z"
        fill={color}
        stroke={color}
      />
    </svg>
  );
}
